import { createFeatureSelector, createSelector } from '@ngrx/store'
import { LayoutState } from './layout-reducers'

export const getLayoutState = createFeatureSelector<LayoutState>('layout')

export const getLayoutColor = createSelector(getLayoutState, (state) => state.LAYOUT_THEME)

export const getSidebarsize = createSelector(getLayoutState, (state) => state.MENU_SIZE)
